<app-maintenance-accordion [items]="activities"></app-maintenance-accordion>